import { queryOptions, useQuery } from '@tanstack/react-query';

import { BestPracticeCheckStandard } from '@cast/types';

import { apiClient } from '@cast/infrastructure-api';

type UseBestPracticeOverviewQuery = {
  standard?: BestPracticeCheckStandard;
  clusterIds?: string[];
  enabled?: boolean;
};

const SECURITY_OVERVIEW_BEST_PRACTICE_QUERY_KEY =
  'security-overview-best-practice';

const getBestPracticeOverviewQueryKey = ({
  standard,
  clusterIds,
}: Pick<UseBestPracticeOverviewQuery, 'standard' | 'clusterIds'>) =>
  [SECURITY_OVERVIEW_BEST_PRACTICE_QUERY_KEY, standard, clusterIds] as const;

const getBestPracticeOverviewQueryOptions = ({
  standard = 'cast',
  clusterIds,
  enabled = true,
}: UseBestPracticeOverviewQuery) =>
  queryOptions({
    queryKey: getBestPracticeOverviewQueryKey({ standard, clusterIds }),
    queryFn: async () => {
      const { data } = await apiClient.securityInsights.getBestPracticeOverview(
        {
          standard,
          clusterIds,
        }
      );
      return data;
    },
    enabled,
  });

export const useBestPracticeOverviewQuery = (
  params: UseBestPracticeOverviewQuery = {}
) => {
  const {
    isLoading,
    data: overview,
    error,
    refetch,
  } = useQuery(getBestPracticeOverviewQueryOptions(params));

  return { isLoading, overview, error, refetch };
};
